module.exports = __webpack_public_path__ + "img/sort.1d4aaa28.svg";